import { useEffect, useRef } from "react";

const SRC = "https://embed.mylocalbusiness.io/widgets/production/latest/widgets.js";

export default function ReviewWidget({ type = "carousel" }: { type?: "carousel" | "blog" }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = "";
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    s.dataset.myWidget = type;
    s.dataset.businessId = process.env.REACT_APP_REVIEWS_BUSINESS_ID || "";
    s.dataset.locationId = process.env.REACT_APP_REVIEWS_LOCATION_ID || "";
    el.appendChild(s);
    return () => { el.innerHTML = ""; };
  }, [type]);
  return <div ref={ref} className="min-h-[200px]" data-testid={type === "blog" ? "blog-widget" : "review-widget"} />;
}
